import PropTypes from 'prop-types'
import { useFormContext } from 'react-hook-form'
import Spinner from 'react-bootstrap/Spinner'
import PrimaryButton from './PrimaryButton'
import theme from '../../constants/theme'

function FormSubmitWithLoading({ text, onSubmit, isLoading, isDisabled }) {
  const { handleSubmit } = useFormContext()
  return (
    <PrimaryButton
      backgroundcolor={theme.brandColorOrange}
      hovercolor={theme.brandColorOrange}
      onClick={handleSubmit(onSubmit)}
      disabled={isLoading || isDisabled}
      width="auto"
      style={{ minWidth: '100px' }}
    >
      {isLoading && (
        <Spinner
          animation="border"
          variant="light"
          size="sm"
          className="me-2"
        />
      )}
      {text}
    </PrimaryButton>
  )
}

FormSubmitWithLoading.propTypes = {
  text: PropTypes.string.isRequired,
  onSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
}

FormSubmitWithLoading.defaultProps = {
  onSubmit: () => {},
  isLoading: false,
  isDisabled: false,
}

export default FormSubmitWithLoading
